import * as R from "ramda";

export default function AidavieFile(data) {
	let aidavieFile = data || {};
	this.id = aidavieFile.id;
	this.firstName = aidavieFile.firstName;
	this.lastName = aidavieFile.lastName;
	this.creationDate = aidavieFile.creationDate;
	this.email = aidavieFile.email;
	this.partnerId = aidavieFile.partnerId;
	this.step = aidavieFile.step;
	this.lifeEvent = aidavieFile.lifeEvent;
	this.agesmaId = aidavieFile.agesmaId;
}
